import React from 'react'
import { Link } from 'gatsby'

import logo from '../img/logo.png'
import facebook from '../img/social/facebook.svg'
import styled from 'styled-components'

const FooterWrap = styled.div`  
  padding-left: 20%;
  width: 60%;
  padding-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  > div {
    padding: 8px;
  }
`;

const SocialWrap = styled.div`
  img {
    width: 1em;
    height: 1em;
  }
`;

const Footer = class extends React.Component {
  render() {
    return (
      <footer>
        <FooterWrap>
          <div>
            <img
              src={logo}
              alt="Logo"
              style={{ width: '7em', height: '3em' }}
            />
          </div>
          <div>          
            <section>
              <ul>
                <li>
                  <Link to="/" className="navbar-item">
                    Home
                  </Link>
                </li>
                <li>
                  <Link className="navbar-item" to="/about">
                    About
                  </Link>
                </li>
                <li>
                  <a
                    className="navbar-item"
                    href="/admin/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Admin
                  </a>                                        
                </li>
              </ul>
            </section>
          </div>
          <SocialWrap>
            <a title="facebook" href="https://facebook.com">
              <img
                src={facebook}
                alt="Facebook"                
              />
            </a>
          </SocialWrap>
        </FooterWrap>
      </footer>
    )
  }
}

export default Footer
